import request from '@/utils/request'

// 常量
const api_name = '/app/meiliSearch'

export default {
    search(query) {
        return request({
            // 接口路径
            url: `${api_name}/search`,
            method: 'get',
            params: query
        })
    },
    clickArticle(id,article) {
        return request({
            // 接口路径
            url: `${api_name}/searchRecords/${id}/click`,
            method: 'patch',
            params: article
        })
    },
}